import { useEffect, useState } from "react";
import Image from 'next/image';


interface RightSideDialogProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  title: JSX.Element | null;
  content: JSX.Element | null;
}

const RightSideDialog = (props: RightSideDialogProps) => {
  const { isVisible, setIsVisible, title, content } = props;
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(isVisible)
  }, [setIsOpen, isVisible])

  useEffect(() => {
    isOpen ? (document.body.style.overflow = 'hidden') : (document.body.style.removeProperty('overflow'));
  }, [isOpen])


  return (
    <>
      <div
        className={`${isOpen ? "fixed left-0 w-screen h-screen top-0 right-0 bottom-0 bg-black opacity-30 z-[54]" : ""}`}
        onClick={() => {
          setIsOpen(!isOpen);
          setIsVisible(!isVisible);
        }}
      ></div>
      <div
        className={`fixed w-full md:w-[468px] z-[55] bg-white top-0 h-dscreen transition-transform ease-in-out duration-300 transform inset-y-0 -right-[100%] md:-right-[468px] py-8 px-6 ${isOpen ? '-translate-x-full' : 'translate-x-0'}`}
      >
        <div className="flex items-center justify-between">
          {title !== null ? (
            <>{title}</>
          ) : (
            <div></div>
          )}
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/close.png"}
            alt="close icon"
            width={14}
            height={14}
            quality={100}
            onClick={() => {
              setIsOpen(!isOpen);
              setIsVisible(!isVisible);
            }}
            className="cursor-pointer"
          />
        </div>
        <hr className="my-4 bg-reviewBg md:my-8" />
        {content}
      </div>
    </>
  )
}

export default RightSideDialog
